<template>
  <div
    v-if="compliance.length > 0 || informational.length > 0"
    class="notification is-warning is-light is-size-7 mb-3"
  >
    <template v-if="compliance.length > 0">
      <p class="mb-1"><strong>FDA Compliance Warnings:</strong></p>
      <ul class="ml-4 warning-list" :class="{ 'mb-3': informational.length > 0 }">
        <li v-for="(warning, i) in compliance" :key="'c' + i">
          {{ warning }}
        </li>
      </ul>
    </template>
    <template v-if="informational.length > 0">
      <p class="mb-1"><strong>Informational Warnings:</strong></p>
      <ul class="ml-4 warning-list">
        <li v-for="(warning, i) in informational" :key="'i' + i">
          {{ warning }}
        </li>
      </ul>
    </template>
  </div>
</template>

<script setup>
  defineProps({
    compliance: { type: Array, default: () => [] },
    informational: { type: Array, default: () => [] },
  });
</script>
